import { useMemo } from 'react';
import { useLocation } from '@gatsbyjs/reach-router';
import { useRecoilValue } from 'recoil';

import { flowActions } from '~/components/page/Automation/v2/state/actions';
import getActionIdFromUrl from '../../utils/getActionIdFromUrl';

type ActionIdFromUrl = {
  actionIdFromUrl: string | null;
  actionExists: boolean;
};

/**
 * Reads `?actionId=` once on mount and checks whether that action exists in the flow.
 * Mount-only so stripping the query param later does not re-trigger consumers.
 */
const useActionIdFromUrl = (): ActionIdFromUrl => {
  const location = useLocation();
  const actions = useRecoilValue(flowActions);

  const actionIdFromUrl = useMemo(
    () => getActionIdFromUrl(location.search),
    // Only read on mount — stripping the param must not re-trigger focus
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const actionExists = Boolean(
    actionIdFromUrl && actions.some(({ id }) => id === actionIdFromUrl),
  );

  return { actionIdFromUrl, actionExists };
};

export default useActionIdFromUrl;
